import { useContext } from 'react'

import { PopoverContext } from '@/context'

export const usePopover = () => useContext(PopoverContext)
